import React from "react";

export default function Privacy() {
  return (
    <div>
      {/* Hero Header */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Privacy Notice
              </h1>
              <p className="fs-4 text-white mb-4 animated slideInDown">
                Your privacy matters to us.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Content */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">

              <p className="mb-4">
                <strong>Last updated:</strong> December 24, 2025
              </p>

              <p className="mb-4">
                At <strong>The Outpost Gentlemen</strong>, we respect your privacy and are
                committed to protecting your personal information. This Privacy Notice
                explains how we collect, use, disclose, and safeguard your information
                when you interact with our website or services.
              </p>

              <h4 className="mt-5 mb-3">Information We Collect</h4>
              <ul className="mb-4">
                <li>Name, email address, and phone number</li>
                <li>Company or organization name</li>
                <li>Information submitted through contact or booking forms</li>
                <li>Scheduling details collected through Calendly</li>
              </ul>

              <h4 className="mt-5 mb-3">How We Use Your Information</h4>
              <ul className="mb-4">
                <li>Respond to inquiries and provide services</li>
                <li>Schedule and manage appointments</li>
                <li>Communicate regarding offerings and updates</li>
                <li>Improve our website and user experience</li>
                <li>Comply with legal obligations</li>
              </ul>

              <h4 className="mt-5 mb-3">Third-Party Services</h4>
              <p className="mb-4">
                We may use trusted third-party services such as Calendly, email providers,
                and analytics tools. These services only access information necessary to
                perform their functions and are required to protect your data.
              </p>

              <h4 className="mt-5 mb-3">Cookies & Tracking</h4>
              <p className="mb-4">
                Our website may use cookies or similar technologies to enhance
                functionality and analyze traffic. You can manage cookie preferences
                through your browser settings.
              </p>

              <h4 className="mt-5 mb-3">Your Privacy Rights</h4>
              <p className="mb-4">
                Depending on your location, you may have rights to access, correct,
                delete, or restrict the use of your personal information. California
                residents and EU/UK residents may have additional rights under applicable
                laws.
              </p>

              <h4 className="mt-5 mb-3">Data Security</h4>
              <p className="mb-4">
                We implement reasonable safeguards to protect your personal information.
                However, no method of online transmission or storage is completely secure.
              </p>

              <h4 className="mt-5 mb-3">Contact Us</h4>
              <p className="mb-1">
                <strong>The Outpost Gentlemen</strong>
              </p>
              <p className="mb-1">Email: info@theoutpostgentlemen.com</p>
              <p className="mb-4">Website: theoutpostgentlemen.com</p>

            </div>
          </div>
        </div>
      </div>
      {/* Privacy Content End */}
    </div>
  );
}
